<template>
  <div class="mt-4 h-max">
    <form>
      <div class="flex flex-col items-left mt-0">
        <div
          class="h-[60px] border-b-2 border-dotted border-gray-400 w-full p-0 flex justify-left items-center bg-white"
        >
          <img
            :src="isSigned ? signedUrl : imageUrl"
            alt=""
            class="max-h-[60px] min-w-[100px] max-w-[200px]"
            v-if="imageUrl || signedUrl"
          />
          <p
            @click="signOrUpload"
            :class="[
              'text-[#8B2923] text-sm cursor-pointer  font-normal',
              { 'cursor-none pointer-events-none': disabled },
            ]"
            v-else
          >
            {{ disabled ? "" : $t("requestFundsTab.clickToSign") }}
          </p>
        </div>
        <input
          type="file"
          @change="handleFileUpload"
          style="display: none"
          ref="fileInput"
          accept="image/*"
        />
      </div>
      <p class="text-gray-700 text-sm !font-semibold !font-['inter'] leading-6">
        {{ signee }}
      </p>
      <p class="text-xs text-gray-700 !font-['inter'] leading-6">
        ( {{ $t(position.getTranslationKey()) }} )
      </p>
      <div
        class="text-gray-700 text-sm !font-['inter'] w-full flex justify-left leading-7"
      >
        <div v-if="dateSigned">
          {{ formattedDate }}
        </div>
        <div v-else class="border-b-2 border-dotted border-gray-400">
          <app-date-picker
            :id="getID"
            class="w-full"
            v-model="date"
            @change="emitDate"
            :show-time="false"
            :show-label="false"
            :show-border="false"
            :disabled="disabled"
          ></app-date-picker>
        </div>
      </div>
    </form>
    <app-dialog
      ref="dialogUploadState"
      width="586"
      height="800"
      :title="$t('contracts.cropAnduploadSiganture')"
      :subtitle="``"
    >
      <template #content>
        <VueCropper
          v-if="selectedFile"
          ref="cropper"
          :src="imageUrl"
          view-mode="1"
          :guides="true"
          :auto-crop="true"
          :auto-crop-area="0.5"
          :movable="true"
          :zoomable="true"
          :drag-mode="'crop'"
          :data="{ width: 400, height: 400 }"
        ></VueCropper>
      </template>
      <template #actions>
        <v-row class="px-4 mt-1 mb-5">
          <v-col cols="6">
            <app-secondary-button
              :buttonLabel="$t('projects.cancel')"
              @click-event="cancelUpload()"
            >
            </app-secondary-button>
          </v-col>
          <v-col cols="6">
            <app-primary-button
              :buttonLabel="$t('contracts.uploadSignature')"
              :loading="isLoading"
              @click-event="cropImage()"
            >
            </app-primary-button>
          </v-col>
        </v-row>
      </template>
    </app-dialog>
    <app-alert
      :title="$t(getTranslatedStringKey(alertTitle))"
      @close-alert="alertState = false"
      :state="alertState"
      :type="alertType"
    />
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { formatDate, getTransString } from "@/services/helpers";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import Api from "@/services/api";
import { uploadEmployeeSignature } from "@/services/endpoints";
import { mapState } from "vuex";

export default defineComponent({
  name: "UploadSignature",
  components: {
    VueCropper,
  },
  props: {
    signee: {
      type: String,
      default: "",
    },
    isSigned: {
      type: Boolean,
      default: false,
    },
    signedUrl: {
      type: String,
      default: "",
    },
    position: {
      type: String,
      default: "",
    },
    dateSigned: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogUploadState: false,
      imageUrl: null,
      selectedFile: null,
      alertType: "success",
      alertState: false,
      alertTitle: "",
      showSignature: false,
      date: new Date().toISOString()?.split("T")[0],
      signed: false,
    };
  },
  watch: {
    isSigned: {
      handler(newValue) {
        this.signed = newValue;
      },
      immediate: true,
    },
  },
  computed: {
    signature() {
      return this.$store.getters["commonResources/signatureImageUrl"];
    },
    formattedDate() {
      return formatDate(this.dateSigned, this.appLocaleLang);
    },
    getID() {
      const randomId = Math.random().toString(36).substring(2, 15);
      return this.position
        ? this.position?.split(" ")?.join("_")?.toLocaleLowerCase() +
            "_" +
            randomId
        : "sign_id_" + randomId;
    },

    appLocaleLang() {
      return this.translation.locale;
    },
    ...mapState(["translation"]),
  },
  methods: {
    emitDate() {
      this.$store.commit(
        "commonResources/SET_SIGNATURE_DATE_TO_STATE",
        this.date
      );
    },

    getTranslatedStringKey(field) {
      return getTransString(field);
    },
    openFileInput() {
      this.showSignature = true;
      this.$refs.fileInput.click();
    },
    cropImage() {
      this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
        this.selectedFile = new File([blob], "cropped-image.jpg", {
          type: "image/jpeg",
        });
        this.imageUrl = URL.createObjectURL(this.selectedFile);
        this.uploadImage();
      }, "image/jpeg");
      this.$refs.dialogUploadState.showDialog = false;
    },
    clearImage() {
      this.imageUrl = null;
      this.$refs.fileInput.value = "";
      this.selectedFile = null;
      this.$refs.dialogUploadState.showDialog = false;
      this.deleteSignature();
    },
    cancelUpload() {
      this.imageUrl = null;
      this.$refs.fileInput.value = "";
      this.selectedFile = null;
      this.$refs.dialogUploadState.showDialog = false;
    },
    signOrUpload() {
      this.showSignature = true;
      this.openFileInput();
      // if (this.signature) {
      //   this.imageUrl = this.signature;
      //   this.signed = true;
      //   this.$store.commit("contractModules/SET_SIGNED_STATUS", this.signed);
      // } else {
      //   this.showSignature = true;
      //   this.openFileInput();
      // }
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) {
        return;
      }
      const validateImageType = ["image/jpeg", "image/png", "image/jpg"];
      if (!validateImageType.includes(file.type)) {
        this.alertType = "error";
        this.alertState = true;
        this.alertTitle = "Please upload a valid image file.";
        return;
      }
      this.selectedFile = file;
      this.imageUrl = URL.createObjectURL(file);
      this.$refs.dialogUploadState.showDialog = true;
    },
    uploadImage() {
      if (!this.selectedFile) {
        this.alertType = "error";
        this.alertState = true;
        this.alertTitle = "Please select an image to upload.";
        return;
      }

      const formData = new FormData();
      formData.append("signature", this.selectedFile);
      Api()
        .post(`${uploadEmployeeSignature}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(async (response) => {
          if (response.data.status === "success") {
            this.alertType = "success";
            this.alertState = true;
            this.alertTitle = response?.data?.detail;
            this.$store.dispatch("commonResources/getSignature");
            this.signed = true;
          }
        })
        .catch((error) => {
          if (error) {
            this.alertType = "error";
            this.alertState = true;
            this.alertTitle = "Error uploading image. Please try again.";
          }
        });
    },
  },
  mounted() {
    this.$store.commit(
      "commonResources/SET_SIGNATURE_DATE_TO_STATE",
      this.date
    );
    // if (!this.signature) {
    //   this.$store.dispatch("commonResources/getSignature");
    // }
  },
});
</script>
